import { RootState } from 'store'

export const selectOrderState = (state: RootState) => state.cart
